import { BoxProps, StackProps, VStack } from '@chakra-ui/react'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'
import React from 'react'

export type FormContainerProps = StackProps & BoxProps

export const FormContainer = (props: FormContainerProps) => {
  const { getBreakpointValue } = useBreakpointContext()

  return (
    <VStack
      align={'stretch'}
      background={'colorPalette.container'}
      border={'1px solid'}
      borderColor={'colorPalette.border/50'}
      borderRadius={'md'}
      boxShadow={'sm'}
      gap={0}
      justify={'stretch'}
      marginX={'auto'}
      padding={getBreakpointValue([4, 8])}
      width={'full'}
      {...props}
    >
      {props.children}
    </VStack>
  )
}
